<template>
  <div class="firstPage">
    <el-scrollbar id="menuWarpper"
                  style="height:calc(100%);">
      <el-main>
        <div class="header"
             ref="header">
          <div class="headerTop">
            <div class="header-con">
              <div class="header-con-form">
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">工单编号:</div>
                  <el-input v-model="gongdanCode"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)"
                            clearable>
                  </el-input>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">客户名称:</div>
                  <el-input v-model="kehumingcheng"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1)">
                  </el-input>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">产品线:</div>
                  <el-select v-model="chanpinxian"
                             placeholder="请选择"
                             clearable
                             multiple
                             size="small"
                             class="form-item-inputcpx"
                             @change="dianjichanpinxian"
                             popper-class="eloption">
                    <!-- :popper-append-to-body="false" -->
                    <el-option v-for="item in staff"
                               :key="item.Code"
                               :label="item.Name"
                               :value="item.Code" />
                  </el-select>
                </div>

                <div class="header-con-form-item">
                  <div class="sousuomingcheng">起始日期:</div>
                  <el-date-picker class="form-item-inputcpx"
                                  :clearable="false"
                                  v-model="kaishishijian"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">终止日期:</div>
                  <el-date-picker class="form-item-inputcpx"
                                  :clearable="false"
                                  v-model="jieshushijian"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>

                <el-button type="success"
                           class="anniuclass"
                           @click="ChaXun(1)"
                           :disabled="isChaXun">查询</el-button>
                <el-button type="primary"
                           class="anniuclass"
                           @click="xinjianGongDan()">新建工单</el-button>
                <!-- <el-button style="margin-right: 10px;" class="anniuclass" type="danger" @click="piliangclwc()"
									:disabled="isPiLiangChuLiWC">批量处理完成
								</el-button> -->

              </div>

            </div>

          </div>

        </div>

        <div class="main"
             v-bind:style="{height:EchartsHeight}">
          <el-table :data="tableData"
                    :cell-style="tableRowStyleName"
                    height="100%"
                    highlight-current-row
                    resizable
                    stripe
                    border
                    @row-dblclick="shuangjiChaKan"
                    @selection-change="handleSelectionChange">
            <!-- <el-table-column align="center" type="selection" label="序号" width="50">
						</el-table-column> -->
            <el-table-column align="center"
                             type="index"
                             label="序号"
                             width="50"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CODE"
                             label="工单号"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="INFO_STATUS1"
                             label="状态"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CUSTOMER_NAME"
                             label="客户名称"
                             min-width="180"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACTS"
                             label="客户联系人"
                             width="100"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACT_INFORMATION"
                             label="客户联系方式"
                             width="100"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="DESCRIBE"
                             label="留言"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="PRODUCT_LINE1"
                             label="产品线"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_TYPE1"
                             label="类型"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="SPONSOR_NAME"
                             label="发起人"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="JOB_NUMBER"
                             label="客服工号"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CUSTOMER_SERVICE_NAME"
                             label="接单人"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="LAUNCH_TIME"
                             label="发起日期"
                             width="190px"
                             show-overflow-tooltip>
              <template v-if="scope.row.LAUNCH_TIME!=null"
                        slot-scope="scope">
                {{scope.row.LAUNCH_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="RECIVE_TIME"
                             label="接单日期"
                             width="190px"
                             show-overflow-tooltip>
              <template v-if="scope.row.RECIVE_TIME!=null"
                        slot-scope="scope">
                {{scope.row.RECIVE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="ESTIMATED_TIME"
                             label="预计完成时间"
                             width="190px"
                             show-overflow-tooltip>
              <template v-if="scope.row.ESTIMATED_TIME!=null"
                        slot-scope="scope">
                {{scope.row.ESTIMATED_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_LEVEL"
                             label="难度等级"
                             width="190px"
                             show-overflow-tooltip>
              <template v-if="scope.row.INFO_LEVEL!=null"
                        slot-scope="scope">
                {{scope.row.INFO_LEVEL}}

              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="Spend_TimeStr"
                             label="处理时长"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column align="center" prop="SPEND_TIME" label="处理时长/小时" show-overflow-tooltip>
							<template v-if="scope.row.SPEND_TIME!=null" slot-scope="scope">
								{{scope.row.SPEND_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

							</template>
						</el-table-column> -->
            <el-table-column align="center"
                             label="操作"
                             fixed="right"
                             width="250px"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDoc(scope)">查看</el-button>
                <el-button type="danger"
                           @click="paidan(scope)">转单</el-button>
                <el-button class="jiedanbtn"
                           type="success"
                           @click="chuliwancheng(scope)"
                           :disabled="isChuLiWanCheng">处理完成</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="footer"
             ref="footer">
          <pagination :allPage="allPage"
                      :pageSize="pageSize"
                      :currIndex="currPage"
                      @hanSiChange="hanSiChange"
                      @hanCurrChange="hanCurrChange"></pagination>
        </div>
      </el-main>
    </el-scrollbar>
    <el-dialog :visible.sync="formDialogZDYY"
               width="600px">

      <!-- <div class="containeraxjgd"> -->
      <div class="headerzhuandanyuanyin">
        <div class="header-con-form"
             :inline="true">
          <div style="width: 16%;">
            客服
          </div>
          <el-input style="width:90%;"
                    type="text"
                    v-model="form.xuanzekefu"
                    @keyup.enter.native="double"
                    placeholder="点回车查询客服"
                    @dblclick.native="double"
                    clearable>
          </el-input>

        </div>
      </div>
      <div class="headerzhuandanyuanyin">
        <div class="header-con-form"
             :inline="true">
          <div style="width: 16%;">
            转单原因
          </div>
          <!-- <el-input style="width:90%;" id="input1" v-model="fankuineirongbh" clearable
						placeholder="选择或输入转单原因！">
		
					</el-input> -->
          <el-autocomplete style="width:90%;"
                           popper-class="my-autocomplete"
                           v-model="state"
                           :fetch-suggestions="querySearch"
                           placeholder="选择或输入转单原因"
                           @select="handleSelect">
            <i class="el-icon-edit el-input__icon"
               slot="suffix"
               @click="handleIconClick">
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.address }}</span>
            </template>
          </el-autocomplete>

        </div>
      </div>
      <div class="tijiaobtnxjgdza">
        <el-button class="tijiaobtnxjgda"
                   @click="formDialogZDYY=false">取消
        </el-button>
      </div>
      <div class="tijiaobtnxjgdza">
        <el-button class="tijiaobtnxjgdb"
                   type="primary"
                   @click="getZhuanDanPaiDan()"
                   :disabled="isQueRenJieDan">
          确认转单
        </el-button>
      </div>
      <!-- </div> -->
    </el-dialog>
    <!-- 评价 -->
    <el-dialog title="评价"
               :visible.sync="formDialog"
               width="800px">
      <div class="dialog-con">
        <el-col :span="24">
          <el-form class="header-con-form"
                   :inline="true">
            <div class="headerpingjia">
              感谢您真挚的评价，我们会继续努力的！
            </div>
          </el-form>
          <div class="taiyangImage">
            <img src="~assets/logo.png"
                 class="taiyangImagez">
          </div>
          <div class="headerfueuxingji">
            <el-form class="header-con-form"
                     :inline="true">

              <div class="fuwuxingjiwz">
                服务星级：
              </div>
              <el-rate v-model="xingji"
                       :colors="colors"
                       show-score
                       text-color="#ffffff"
                       score-template="{value}">
              </el-rate>

            </el-form>
          </div>
          <div class="headermiaoshu">
            <el-form class="header-con-form"
                     :inline="true">

              <div class="fuwuxingjiwza">
                留言板：
              </div>
              <el-input class="form-item-input"
                        type="textarea"
                        :rows="8"
                        placeholder="请输入内容"
                        v-model="miaoshu">
              </el-input>

            </el-form>
          </div>

        </el-col>
      </div>
      <div slot="footer">
        <el-button type="primary"
                   @click="tijiaopingjia()"
                   :disabled="isTiJiaoPingJia">提交</el-button>

      </div>
    </el-dialog>
    <el-dialog title="选择客服"
               :visible.sync="formDialogkf"
               width="80%"
               height="80%">
      <div class="containera">
        <el-card class="headera">
          <div class="header-cona">
            <el-form class="header-con-form"
                     :inline="true"
                     @submit.native.prevent>
              <el-form-item class="header-con-form-item"
                            label="客服姓名:">
                <el-input v-model="form.xuanzekefu"
                          style="width: 200px"
                          placeholder="请输入"
                          ref="kefuchaxun"
                          @change="getKefumingdan(1)"
                          @keyup.enter.native="getKefumingdan(1)">
                </el-input>
              </el-form-item>
              <el-button type="primary"
                         @click="getKefumingdan(1)"
                         :disabled="isChaXunkfm">查询</el-button>
            </el-form>

          </div>
          <div>

          </div>
        </el-card>
        <div class="main"
             v-bind:style="{height:EchartsHeight}">
          <el-table :data="tableDatakf"
                    height="100%"
                    highlight-current-row
                    resizable
                    stripe
                    border
                    @row-dblclick="handledbClickkf">
            <el-table-column align="center"
                             type="index"
                             label="序号"
                             width="50">
            </el-table-column>
            <el-table-column align="center"
                             prop="NAME"
                             label="姓名">
            </el-table-column>
            <el-table-column align="center"
                             prop="JOB_NUMBER"
                             label="编号">
            </el-table-column>
            <el-table-column align="center"
                             prop="PRODUCT_LINE1"
                             label="产品线">
            </el-table-column>
            <el-table-column align="center"
                             prop="ROLE_NAME"
                             label="角色">
            </el-table-column>

            <el-table-column align="center"
                             label="操作"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDockf(scope)">
                  选择</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer"
             ref="footer">
          <pagination :allPage="allPagekf"
                      :pageSize="pageSizekf"
                      :currIndex="currPagekf"
                      @hanSiChange="hanSiChangekf"
                      @hanCurrChange="hanCurrChangekf"></pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="formDialogQRCLWC"
               width="600px">

      <!-- <div class="containeraxjgd"> -->
      <div class="headerzhuandanyuanyin">
        <el-form class="header-con-form"
                 :inline="true">
          <div style="margin-left: 10px;;margin-bottom: 10px;color: black;font-size: 13px;">

            工单号:{{CLWCGDH}}
          </div>
          <div style="margin-bottom: 10px;margin-left: 10px;color: black;font-size: 13px;">

            客户名称:{{CLWCKHMC}}
          </div>

        </el-form>
      </div>
      <div class="headerzhuandanyuanyin">
        <el-form class="header-con-form"
                 :inline="true">
          <div style="width: 16%;">
            <div style="color: red;display: inline-block;">
              *
            </div>
            问题类型
          </div>
          <el-select style="margin-left: 10px;"
                     class="form-item-inputtckwtlx"
                     v-model="wentileixingXin"
                     filterable
                     placeholder="输入关键词搜索">
            <el-option v-for="item in WenTileixingList"
                       :key="item.Code"
                       :label="item.Name"
                       :value="item.Code">
            </el-option>
          </el-select>
        </el-form>
      </div>
      <div class="headerzhuandanyuanyin">
        <div class="header-con-form"
             :inline="true">
          <div style="width: 16%;">
            <div style="color: red;display: inline-block;">
              *
            </div>
            问题原因
          </div>

          <el-select style="margin-left: 10px;"
                     class="form-item-inputtckwtlx"
                     v-model="stateCLWC"
                     filterable
                     placeholder="选择问题原因">
            <el-option v-for="item in restaurantsCLWC"
                       :key="item.Code"
                       :label="item.Name"
                       :value="item.Code">
            </el-option>
          </el-select>

        </div>
      </div>
      <div class="tijiaobtnxjgdza">
        <el-button class="tijiaobtnxjgda"
                   @click="formDialogQRCLWC=false">取消
        </el-button>
      </div>
      <div class="tijiaobtnxjgdza">
        <el-button class="tijiaobtnxjgdb"
                   type="primary"
                   @click="getQueRenChuLiWanCheng()"
                   :disabled="isQueRenJieDan">
          确认处理完成
        </el-button>
      </div>
      <!-- </div> -->
    </el-dialog>

  </div>
</template>

<script>
import PinyinMatch from "pinyin-match";
export default {
  name: "kefuyijiegongdan",
  data () {
    return {
      CLWCGDH: "",
      CLWCKHMC: "",
      restaurantsCLWC: [],
      formDialogQRCLWC: false,
      gongdanCode: "",
      form: {

        xuanzekefu: "",
        kefubianhao: "",

      },
      isChuLiWanCheng: false,
      isQueRenJieDan: false,
      restaurants: [],
      state: "",
      formDialogZDYY: false,
      isTiJiaoPingJia: false,
      isPiLiangChuLiWC: false,
      isChaXun: false,
      isChaXunkfm: false,
      formDialogkf: false,
      multipleSelection: [],
      EchartsHeight: (document.body.clientHeight - 200) + 'px',
      tableDatakf: [],
      xingji: 4,
      currPagekf: 1,
      pageSizekf: 50,
      allPagekf: 0,
      miaoshu: "",
      pingjiaxuanzhong: 0,
      formDialog: false,
      formxjgdlog: false,
      formxzkhlog: false,
      chanpinxian: "", //产品线
      colors: ['#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00', '#FFFF00'],
      staffcopy: [],
      staff: [], //产品线
      staffz: [], //产品线
      kehumingcheng: "",
      templateName: "",
      kaishishijian: "",
      jieshushijian: "",
      loading: false,
      currPage: 1,
      pageSize: 50,
      allPage: 0,
      value: "",
      shijian: "",
      tableData: [],
      stateCLWC: "",
      wentileixingXin: "",
      WenTileixingList: [],
      sfdycjr: 0,

    };
  },

  mounted () {
    this.restaurants = this.loadAll();
    const that = this;
    // window.onresize = () => {
    // 	// return (() => {
    // 	window.screenHeight = document.body.clientHeight
    // 	that.EchartsHeight = (window.screenHeight - 200) + 'px'
    // 	that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
    // 	// })()
    // }
    window.onresize = () => {
      // return (() => {

      window.screenHeight = document.body.clientHeight

      that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'
      that.EchartsHeightxjgd = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'
      that.scrollbarHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'

      // })()
    }
    if (this.sfdycjr == 0) {
      this.getPerson()
      this.getWenTileixing()


      this.addDate();
    }
    this.currPage = 1;
    this.ChaXun(this.currPage);


  },
  activated () {
    const that = this;
    this.loadAllCLWC()
    // window.onresize = () => {
    // 	// return (() => {
    // 	window.screenHeight = document.body.clientHeight
    // 	that.EchartsHeight = (window.screenHeight - 200) + 'px'
    // 	that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
    // 	// })()
    // }
    window.onresize = () => {
      // return (() => {

      window.screenHeight = document.body.clientHeight

      that.EchartsHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'
      that.EchartsHeightxjgd = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'
      that.scrollbarHeight = (window.screenHeight - this.$refs.header.offsetHeight - this.$refs
        .footer.offsetHeight - 70) + 'px'

      // })()
    }
    if (this.sfdycjr == 0) {
      this.getPerson()
      this.getWenTileixing()


      this.addDate();
    }
    this.currPage = 1;
    this.ChaXun(this.currPage);
  },
  beforeRouteEnter (to, form, next) {
    next(vm => {
      vm.ChaXun(1)

    })

  },
  methods: {
    tableRowStyleName ({
      row
    }) {
      if (row.beijingse == 'huang') {
        return 'background-color: #FF9D00 !important;color:#ffffff';
      }

      if (row.beijingse == 'hong') {
        return 'background-color: #FF3A3A !important;color:#ffffff';
      }
      if (row.beijingse == 'hei') {
        return 'background-color: #ffffff !important;color:#000000';
      }
    },

    // tableRowClassName({row}){
    // 	console.log("tableRowClassName",row)
    // },
    doHandleMonth (month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDayCR (day, crday) {

      var today = new Date(crday);
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var tHours = today.getHours();
      var tMinutes = today.getMinutes();
      var tSeconds = today.getSeconds();

      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      tHours = this.doHandleMonth(tHours);
      tMinutes = this.doHandleMonth(tMinutes);
      tSeconds = this.doHandleMonth(tSeconds);
      return tYear + "-" + tMonth + "-" + tDate + " " + tHours + ":" + tMinutes + ":" + tSeconds;
    },
    compare (date1, date2) {
      console.log("开始", date1, '结束', date2)
      let dates1 = new Date(date1);
      let dates2 = new Date(date2);
      if (dates1 > dates2) {
        return true
      } else {
        return false
      }
    },
    currentTime () {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      console.log("month", month);
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      // console.log("strDate", strDate);
      return strDate;
    },
    loadAllCLWC () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetInfoReason",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            // this.WenTileixingList = res.Data;
            this.restaurantsCLWC = res.Data;
          }

        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    chuliwancheng (row) {
      console.log(row)

      this.CLWCGDH = row.row.CODE;
      this.CLWCKHMC = row.row.CUSTOMER_NAME;
      this.wentileixingXin = "";
      this.stateCLWC = "";
      // 
      // this.$confirm('确定工单号：'+row.row.CODE+' 客户名称：'+row.row.CUSTOMER_NAME+'处理完成了么?', '提示', {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消',
      // 	type: 'warning'
      // }).then(() => {
      this.formDialogQRCLWC = true;
      // });
    },
    //处理完成
    getQueRenChuLiWanCheng () {
      // this.$confirm('确定处理完成了么?', '提示', {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消',
      // 	type: 'warning'
      // }).then(() => {
      this.scoped = true;
      this.isChuLiWanCheng = true;

      if (this.wentileixingXin == null || this.wentileixingXin == "" || this.wentileixingXin ==
        undefined) {
        // this.wentileixingXin=this.xiangqing[0].INFO_TYPE;
        this.$message({
          type: 'none',
          message: "问题类型不能为空"
        });
        this.isChuLiWanCheng = false;
        return;
      }
      if (this.stateCLWC == null || this.stateCLWC == "" || this.stateCLWC == undefined) {
        this.$message({
          type: 'none',
          message: "问题原因不能为空"
        });
        this.isChuLiWanCheng = false;
        return;
      }
      let data = {

        CODE: this.CLWCGDH, //工单号
        INFO_REASON: this.stateCLWC, //工单问题原因
        INFO_TYPE: this.wentileixingXin, //问题类型

      };
      this.$request({
        method: "post",
        url: "Info/HandleChuLiWc",
        data: data
      })
        // 	this.$request({
        // 			method: "post",
        // 			url: 'Info/HandleChuLiWc?CODE=' + encodeURIComponent(this.code) + '&status=3'

        // 		})
        .then(() => {
          this.isChuLiWanCheng = false;
          this.formDialogQRCLWC = false;
          this.$message({
            message: "处理完成！",
            type: "success"
          });
          this.ChaXun(1)

        })
        .catch((err) => {
          this.isChuLiWanCheng = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login"
            });
          }
        });
      // });
    },
    //客服双击
    handledbClickkf (row) {
      if (row.ROLE_NAME == "客服") {
        this.$confirm('确定将工单号' + this.dangqiandanhao + '转单给' + row.NAME + '么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let data = {

            code: this.dangqiandanhao, //工单号
            job_number: row.JOB_NUMBER, //工号

          };
          this.$request({
            method: "post",
            url: "Info/Transfer",
            data: data,
          })
            .then((res) => {
              if (res.Code == '0' || res.Code == 0) {
                this.$message({
                  type: 'success',
                  message: '转单' + res.Msg + '!'
                });
                if (res.Msg == "成功") {
                  this.formDialogkf = false;
                  this.ChaXun(1)
                }
              }


            })
            .catch((err) => {
              if (err == "Error: Request failed with status code 401") {
                this.$router.push({
                  path: "/login",
                });
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消派单'
          });
        });
        // this.kefumingcheng = row.NAME;
        // this.kefubianhao = row.JOB_NUMBER;
        // this.formDialogkf = false;
        // if (this.kefumingcheng != "") {
        // 	this.form.xuanzekefu = this.kefumingcheng;
        // } else {
        // 	this.form.xuanzekefu = "";
        // }
      } else {
        this.$message({
          message: "仅可下发给客服！",
          type: "error",
        });
      }


    },
    /**查看分类下文档 */
    viewDockf (row) {
      console.log(row.row.NAME, row.row.JOB_NUMBER);
      this.form.xuanzekefu = row.row.NAME;
      this.form.kefubianhao = row.row.JOB_NUMBER;
      this.formDialogkf = false;
      // this.getZhuanDanPaiDan()
      // if (this.kefumingcheng != "") {
      // 	this.form.xuanzekefu = this.kefumingcheng;
      // } else {
      // 	this.form.xuanzekefu = "";
      // }
    },
    getZhuanDanPaiDan () {
      if (this.form.kefubianhao == null || this.form.kefubianhao == "" || this.form.kefubianhao ==
        undefined) {
        this.$message({
          type: 'none',
          message: "请选择转单客服"
        });
        return;
      }
      if (this.state == null || this.state == "" || this.state == undefined) {
        this.$message({
          type: 'none',
          message: "转单原因不能为空"
        });
        return;
      }
      this.$confirm('确定将工单号' + this.dangqiandanhao + '转单给' + this.form.xuanzekefu + '么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let data = {

          code: this.dangqiandanhao, //工单号
          job_number: this.form.kefubianhao, //工号
          reason: this.state

        };
        this.$request({
          method: "post",
          url: "Info/Transfer",
          data: data,
        })
          .then((res) => {
            if (res.Code == '0' || res.Code == 0) {
              this.$message({
                type: 'success',
                message: '转单' + res.Msg + '!'
              });

              if (res.Msg == "成功") {
                this.formDialogkf = false;
                this.formDialogZDYY = false;
                this.ChaXun(1)
              }

            }


          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消派单'
        });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    paidan (row) {
      this.formDialogZDYY = true;
      this.dangqiandanhao = row.row.CODE;
    },
    double () {

      this.formDialogkf = true
      this.getKefumingdan(1)
      this.$nextTick(() => {
        this.$refs.kefuchaxun.focus()
      })
    },
    /**获取客服名单 */
    getKefumingdan (index) {
      this.currPagekf = index;

      // this.loading = true;
      this.isChaXunkfm = true;
      this.$request({
        method: "GET",
        url: 'ACCOUNT/GetServiceAccountList?zh=' + encodeURIComponent(this.form.xuanzekefu) +
          "&status=-1&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(
            this
              .pageSizekf),

      })
        .then((res) => {
          this.isChaXunkfm = false;
          this.formDialogkf = true
          // this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            this.tableDatakf = res.Data;

          }
          if (this.tableDatakf.length > 0) {
            for (var i in this.tableDatakf) {


              var bdcpx = this.tableDatakf[i].PRODUCT_LINE.split(',');
              var xin = [];
              for (var z in bdcpx) {
                for (var j in this.staff) {
                  if (bdcpx[z] == this.staff[j].Code) {
                    xin.push(this.staff[j].Name)
                    this.$set(this.tableDatakf[i], 'PRODUCT_LINE1', xin.join(','))
                  }

                }

              }



            }
          }
          this.allPagekf = res.Total;
        })
        .catch((err) => {
          this.isChaXunkfm = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    piliangclwc () {
      var arr = [];

      var url = 'Info/BulkUpdateStatus';
      for (var z in this.multipleSelection) {
        arr.push(this.multipleSelection[z].CODE);
      }
      let data = {

        codes: arr,
        status: '3',

      };
      if (arr.length > 0) {

        this.$confirm('处理完成不可逆，确定批量处理完成么?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isPiLiangChuLiWC = true;
          this.$request({
            method: "POST",
            url: url,
            data: data
          })
            .then((res) => {
              this.isPiLiangChuLiWC = false;
              this.$message({
                message: res.Msg,
                type: "success",
              });
              this.ChaXun(1)

            })
            .catch((err) => {
              this.isPiLiangChuLiWC = false;
              if (err == "Error: Request failed with status code 401") {
                this.$router.push({
                  path: "/login",
                });
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消批量删除'
          });
        });

      }
    },
    dianjichanpinxian () {
      this.staff = this.staffz;
      this.ChaXun(1)
    },
    bindSelectChange (val) {

      if (val) {
        this.staff = this.staffcopy.filter((item) => {
          return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
        })
      } else {
        this.staff = this.staffcopy
      }

    },

    //双击查看工单
    shuangjiChaKan (row) {
      this.$router.push({
        path: "gongdanxiangqing",
        query: {
          zhuangtai: 'N',
          qianyiyemingcheng: '已接工单',
          code: row.CODE,
          qianyiyemianglujing: "/home/kefuyijiegongdan"

        }
      });


    },

    /**获取类型*/
    getWenTileixing () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetGdLx",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            this.WenTileixingList = res.Data;
          }

        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    //评价
    pingjia (row) {

      this.pingjiaxuanzhong = row;
      this.formDialog = true;
    },
    //提交评价
    tijiaopingjia () {
      let data = {

        CODE: this.tableData[this.pingjiaxuanzhong].CODE, //产品线
        SERVICE_EVALUATE: this.miaoshu, //服务评价
        SERVICE_STAR: this.xingji, //服务星级

      };
      // this.formDialog = true;

      this.scoped = true;
      this.isTiJiaoPingJia = true;
      this.$request({
        method: "post",
        url: "Info/UploadPingJia",
        data: data,
      })
        .then(() => {
          this.isTiJiaoPingJia = false;
          this.$message({
            message: "发起成功！",
            type: "success",
          });

          this.miaoshu = '';
          this.xingji = 5;
          this.formDialog = false;

        })
        .catch((err) => {
          this.isTiJiaoPingJia = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    //查询
    ChaXun (index) { //客服已接工单
      this.currPage = index;
      this.loading = true;
      this.isChaXun = true;
      window.localStorage.setItem('kfyjstartDate', this.kaishishijian)
      window.localStorage.setItem('kfyjendDate', this.jieshushijian)
      this.$request({
        method: "GET",
        url: 'Info/GetWclwcInfoList?customname=' + encodeURIComponent(this.kehumingcheng) +
          "&chanpx=" + encodeURIComponent(this.chanpinxian) + "&startDate=" +
          encodeURIComponent(
            this.kaishishijian + " 00:00:00") + "&endDate=" + encodeURIComponent(this
              .jieshushijian + " 23:59:59") + "&code=" + encodeURIComponent(this.gongdanCode) +
          "&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this
            .pageSize),

      })
        .then((res) => {
          this.isChaXun = false;
          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            this.tableData = res.Data;

          }
          if (this.tableData.length > 0) {
            for (var i in this.tableData) {
              this.$set(this.tableData[i], 'beijingse', "hei");
              if (this.tableData[i].INFO_STATUS == 2) {

                var liushitianqian = this.getDayCR(7, this.tableData[i].RECIVE_TIME);
                var liushitianqiancgs = this.getDayCR(4, this.tableData[i].RECIVE_TIME);
                var liushitianqianxqcq = this.getDayCR(14, this.tableData[i].RECIVE_TIME);
                if (this.tableData[i].INFO_TYPE == 201) {
                  if (this.compare(this.currentTime(), liushitianqiancgs)) {

                    this.$set(this.tableData[i], 'beijingse', "huang");
                  }
                  if (this.compare(this.currentTime(), liushitianqian)) {

                    this.$set(this.tableData[i], 'beijingse', "hong");
                  }
                } else {
                  if (this.compare(this.currentTime(), liushitianqiancgs)) {

                    this.$set(this.tableData[i], 'beijingse', "huang");
                  }
                  if (this.compare(this.currentTime(), liushitianqianxqcq)) {

                    this.$set(this.tableData[i], 'beijingse', "hong");
                  }
                }

              }
              if (this.tableData[i].INFO_STATUS == 0) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已撤销')
              } else if (this.tableData[i].INFO_STATUS == 1) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已发起')
              } else if (this.tableData[i].INFO_STATUS == 2) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已接单')
              } else if (this.tableData[i].INFO_STATUS == 3) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已处理')
              } else if (this.tableData[i].INFO_STATUS == 4) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已驳回')
              } else if (this.tableData[i].INFO_STATUS == 5) {
                this.$set(this.tableData[i], 'INFO_STATUS1', '已完成')
              }
              for (var j in this.staff) {
                if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                  this.$set(this.tableData[i], 'PRODUCT_LINE1', this.staff[j].Name)
                }
              }
              for (var z in this.WenTileixingList) {
                if (this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code) {
                  this.$set(this.tableData[i], 'INFO_TYPE1', this.WenTileixingList[z].Name)
                }
              }


            }
          }
          if (this.$refs.header.offsetHeight == 0) {
            this.EchartsHeight = (document.body.clientHeight - 230) + 'px'

          } else {
            this.EchartsHeight = (document.body.clientHeight - this.$refs.header.offsetHeight -
              130) + 'px'

          }
          this.allPage = res.Total;
        })
        .catch((err) => {
          this.isChaXun = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });

    },
    //新建工单
    xinjianGongDan () {
      this.$router.push({
        path: "xinjiangongdan"
      });

    },

    /**获取产品线 */
    getPerson () {
      this.loading = true;


      this.$request({
        method: "GET",
        url: "Dictionary/GetProducts",
      })
        .then((res) => {

          this.loading = false;
          if (res.Code == '0' || res.Code == 0) {
            var arr = [];


            var bdcpx = JSON.parse(localStorage.getItem("userInfo")).PRODUCT_LINE.split(',');

            for (var i in res.Data) {
              for (var j in bdcpx) {

                if (res.Data[i].Code == bdcpx[j]) {
                  arr.push(res.Data[i])
                }

              }

            }
            this.staff = arr;
            this.staffz = arr;
            this.staffcopy = this.staff;


          }

        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    /**查看分类下文档 */
    viewDoc (row) {

      this.$router.push({
        path: "gongdanxiangqing",
        query: {
          zhuangtai: 'N',
          qianyiyemingcheng: '已接工单',
          code: row.row.CODE,
          qianyiyemianglujing: "/home/kefuyijiegongdan"
        }
      });
    },




    getPath () {
      this.$router.push({
        path: "/login",
      });
    },

    addDate () {
      let nowDate = new Date();
      var targetday_milliseconds = nowDate.getTime() - 1000 * 60 * 60 * 24 * 63;
      nowDate.setTime(targetday_milliseconds);
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };


      if (date.month < 10) {
        date.month = '0' + date.month; //补齐
      }
      if (date.date < 10) {
        date.date = '0' + date.date; //补齐
      }
      // let shijianshuzu = [];
      let shijian = date.year + "-" + date.month + "-01";

      this.kaishishijian = shijian;




      let nowDatejt = new Date();

      let datejt = {
        year: nowDatejt.getFullYear(),
        month: nowDatejt.getMonth() + 1,
        date: nowDatejt.getDate(),
      };


      if (datejt.month < 10) {
        datejt.month = '0' + datejt.month; //补齐
      }
      if (datejt.date < 10) {
        datejt.date = '0' + datejt.date; //补齐
      }
      // let shijianshuzu = [];
      let shijianjt = datejt.year + "-" + datejt.month + "-" + datejt.date;


      this.jieshushijian = shijianjt;
      // if (window.localStorage.getItem('kfyjstartDate') != "null" && window.localStorage.getItem(
      // 		'kfyjstartDate') != "") {
      // 	this.kaishishijian = window.localStorage.getItem('kfyjstartDate');
      // 	this.jieshushijian = window.localStorage.getItem('kfyjendDate');
      // }
    },







    /**分页size改变 */
    hanSiChangekf (val) {
      this.pageSizekf = val;
      this.currPagekf = 1;
      this.getKefumingdan(1);
    },
    /**当前页改变 */
    hanCurrChangekf (val) {
      this.currPagekf = val;
      this.getKefumingdan(this.currPagekf);
    },
    /**刷新表格数据 */
    handleRefreshkf () {
      this.currPagekf = 1;
      this.getKefumingdan(this.currPagekf);
    },
    /**分页size改变 */
    hanSiChange (val) {
      this.pageSize = val;
      this.currPage = 1;
      this.ChaXun(this.currPage);
    },
    /**当前页改变 */
    hanCurrChange (val) {
      this.currPage = val;
      this.ChaXun(this.currPage);
    },
    /**刷新表格数据 */
    handleRefresh () {
      this.currPage = 1;
      this.ChaXun(this.currPage);
    },
    //转单
    querySearch (queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAll () {
      return [{
        "value": "功能违背业务逻辑，不能实现",
        "address": ""
      },
      {
        "value": "无法实现客户需求，需要商务层面给客户沟通",
        "address": ""
      },
      {
        "value": "此需求无法满足，需要商务具体了解客户想法，客服来出具更合理的方案 此需求需要付费，预计工时为xx人/天，请商务层面沟通",
        "address": ""
      },
      {
        "value": "此需求不够明确，需实施/去过现场的人员确定客户实际情况后再进行工单处理",
        "address": ""
      }
      ];
    },
    handleSelect (item) {
      console.log(item);
    },
    handleIconClick (ev) {
      console.log(ev);
    }


  },
};
</script>

<style scoped>
.firstPage {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  padding-left: 0px;
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: auto;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: auto;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
}

.header-con-form-item {
  margin-bottom: 10px;
}

.headerpingjia {
  margin-bottom: 0;
  text-align: center;
  width: 100%;
  font-size: 20px;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.item {
  width: 100%;
  height: 100%;
}

.itema {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  height: 30px;
}

.itemb {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 0px;
  bottom: 0px;
}

.fankuiImage {
  width: 100%;
  height: 100%;
}

.itemaBoxa {
  float: left;
  margin-top: 3px;
  margin-left: 0px;
  margin-left: 4px;
  width: 100px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxb {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 200px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxc {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 100px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  height: 80px;
}

.itemBoxa {
  float: left;
  top: 20px;
  left: 0px;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

/* 	/deep/ .el-dialog {
		max-height: 80%;
	} */

.itemBoxb {
  float: left;
  top: 20px;
  left: 20%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxc {
  float: left;
  top: 20px;
  left: 40%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxd {
  float: left;
  top: 20px;
  left: 60%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 25px;
  /* border-bottom: 1px solid #F2F4F9; */
}

.itemTopText {
  float: left;
  width: 80px;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-left: 10rpx;
}

.sousuoyou {
  float: right;
  margin-top: 20px;
  /* right: 30px; */
  margin-right: 20px;
  width: 92px;
  height: 36px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  /* width: 100%;
  height: 100%; */
  overflow: hidden;
  /* background-color: #fff; */
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;

  overflow-y: auto;
  margin-right: 0px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  overflow-y: auto;
  margin-right: 0px;
}

.yemakuandu {
  width: 99%;
  background-color: #fff;
  height: 40px;
  padding-top: 20px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

/**dialog中样式 */
.dialog-cona {
  height: auto;
  overflow: auto;
}

.itemc {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  /* height: 98%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemcBoxa {
  width: 49.95%;
  height: 70px;
  max-height: 100px;
  float: none;

  background-color: #fff;
}

.itemd {
  box-sizing: border-box;
  width: 100%;
  height: 98%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemdtext {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 80%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

.itemdtexta {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 16%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

.taiyangImage {
  display: flex;
  justify-content: center;
  align-items: center;
}

.taiyangImagez {
  margin: 10px;
  width: 92px;
  height: 92px;
}

.fuwuxingjiwz {
  height: 40px;
  line-height: 60px;
}

.fuwuxingjiwza {
  height: 140px;
  margin-top: -20px;
  font-size: 16px;
}

/deep/.el-rate__icon {
  font-size: 40px;
}

/deep/ .iconyishoucang {
  color: #ffff00;
  font-size: 22px;
}

/deep/ .iconshoucang {
  color: #bbb;
  font-size: 22px;
}

.headermiaoshu {
  margin-bottom: 0;
  margin-top: 20px;
  margin-left: 25%;
  width: 70%;
  font-size: 16px;
  color: #666666;
}

/**输入框宽度 */
.form-item-input {
  width: 450px;
}
/**输入框宽度 */
.form-item-inputtckwtlx {
  width: 350px;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 180px;
}

.headerfueuxingji {
  margin-bottom: 0;
  margin-top: 0;
  margin-left: 25%;
  width: 50%;
  font-size: 16px;
  color: #666666;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.headerxjgd {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headeraxjgd {
  margin-bottom: 2px;
}

.fanhuiBtnxjgd {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.yonghuminglabexjgd {
  margin-top: 0px;
  margin-left: 90px;
  margin-bottom: 20px;
  display: inline-block;
}

/* 主体容器 */
.mainxjgd {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  box-sizing: border-box;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

.tijiaobtnxjgd {
  /* display: flex; */
  margin-top: 30px;
  margin-left: 50%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
}

.header-conxjgd {
  margin-left: 0px;
}

.header-conaxjgd {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-formxjgd {
  display: flex;
  align-items: center;
}

.header-con-form-itemxjgd {
  margin-bottom: 0;
}

/**输入框宽度 */
.form-item-inputxjgd {
  width: 470px;
}

/**输入框宽度 */
.form-item-inputxjgdms {
  width: 1149px;
}

/**输入框后面的备注 */
.form-item-tipxjgd {
  display: inline-block;
  margin-left: 10px;
  color: #606266;
  font-size: 14px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarxjgd {
  width: 178px;
  height: 178px;
  display: block;
}

.shangchuantupianxjgd {
  margin-left: 90px;
  margin-bottom: 20px;
  width: 1149px;
}

.shangchuantupianxxjgd {
  margin-left: 10px;
  margin-top: 10px;

  display: inline-block;
}

.mediumxjgd {
  width: 470px;
  height: 30px;
  text-align: left;
  color: #999999;
  font-weight: 400;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}

.headerzhuandanyuanyin {
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 5%;
  width: 90%;
  font-size: 16px;
  color: #666666;
}

.header-con-form {
  display: flex;
  align-items: center;
}

/deep/.el-autocomplete {
  width: 90%;
}

.tijiaobtnxjgdza {
  /* display: flex; */
  margin-top: 30px;
  text-align: center;
  /* margin-left: 100px; */
  width: 50%;
  display: inline-block;
}

.sousuomingcheng {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 400;
}
.anniuclass {
  margin-left: 20px;
  /* margin-top: 10px; */
  margin-bottom: 15px;
}
.weijiekongdan {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  padding-left: 0px;
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: auto;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: auto;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-wrap: break-word;
  overflow: hidden;
  margin: auto;
  /* 看自己需要设置，不影响div高度变化*/
}

.header-con-form-item {
  margin-bottom: 15px;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.item {
  width: 100%;
  height: 100%;
}

.itema {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  height: 30px;
}

.itemb {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 0px;
  bottom: 0px;
}

.itemaBoxa {
  float: left;
  margin-top: 3px;
  margin-left: 0px;
  margin-left: 4px;
  width: 100px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxb {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 200px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxc {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 100px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  height: 80px;
}

.itemBoxa {
  float: left;
  top: 20px;
  left: 0px;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxb {
  float: left;
  top: 20px;
  left: 20%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxc {
  float: left;
  top: 20px;
  left: 40%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxd {
  float: left;
  top: 20px;
  left: 60%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.anniuclass {
  margin-left: 20px;
  /* margin-top: 10px; */
  margin-bottom: 15px;
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 25px;
  /* border-bottom: 1px solid #F2F4F9; */
}

.itemTopText {
  float: left;
  width: 80px;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-left: 10rpx;
}

.sousuoyou {
  float: right;
  margin-top: 20px;
  /* right: 30px; */
  margin-right: 20px;
  width: 92px;
  height: 36px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  /* width: 100%;
	height: 100%; */
  overflow: hidden;
  /* background-color: #fff; */
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

.yemakuandu {
  width: 99%;
  background-color: #fff;
  height: 40px;
  padding-top: 20px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

.itemc {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  /* height: 98%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemcBoxa {
  width: 49.95%;
  height: 70px;
  max-height: 100px;
  float: none;

  background-color: #fff;
}

.itemd {
  box-sizing: border-box;
  width: 100%;
  height: 98%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemdtext {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 80%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

.itemdtexta {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 16%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 200px;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.headerxjgd {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headeraxjgd {
  margin-bottom: 2px;
}

.fanhuiBtnxjgd {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.yonghuminglabexjgd {
  margin-top: 0px;
  margin-left: 90px;
  margin-bottom: 20px;
  display: inline-block;
}

/* 主体容器 */
.mainxjgd {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

.tijiaobtnxjgd {
  /* display: flex; */
  margin-top: 30px;
  margin-left: 50%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
}

.tijiaobtnxjgdza {
  /* display: flex; */
  margin-top: 30px;
  text-align: center;
  /* margin-left: 100px; */
  width: 50%;
  display: inline-block;
}

.tckmingcheng {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

.tckmingchenga {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.tijiaobtnxjgda {
  /* display: flex; */
  margin-top: 0px;
  margin-left: 40%;
  margin-bottom: 20px;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.tijiaobtnxjgdb {
  /* display: flex; */
  margin-top: 0px;
  margin-bottom: 20px;
  margin-right: 20%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.header-conxjgd {
  margin-left: 0px;
}

.header-conaxjgd {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-formxjgd {
  display: flex;
  align-items: center;
}

.sousuomingcheng {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 400;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarxjgd {
  width: 178px;
  height: 178px;
  display: block;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>
